export function getSubdomain(): string {
  // Before the crawl check: the school build also sets NEXT_PUBLIC_IS_CRAWL_WEBSITE
  if (process.env.NEXT_PUBLIC_IS_SCHOOL_PLATFORM === 'true') return 'school'
  if (process.env.NEXT_PUBLIC_IS_ALPHA_WEBSITE === 'true') return 'alpha'
  if (process.env.NEXT_PUBLIC_IS_CRAWL_WEBSITE === 'true') return 'roar'
  if (process.env.NEXT_PUBLIC_IS_BETA_WEBSITE === 'true') return 'beta'
  if (process.env.NEXT_PUBLIC_IS_PRODUCTION_WEBSITE === 'true' || typeof window === 'undefined') return 'www'
  return window.location.hostname
}
